"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var index_1 = require("../../utils/index");
var useStyles = index_1.makeStyles(function (theme) { return ({
    s: {
        cursor: 'pointer',
        color: theme.palette.primary.main
    }
}); });
var maxLengthDefault = 50;
exports["default"] = (function (_a) {
    var text = _a.text, children = _a.children, _b = _a.maxLength, maxLength = _b === void 0 ? maxLengthDefault : _b;
    var _c = react_1["default"].useState(false), isExpanded = _c[0], setExpand = _c[1];
    var len = text.length;
    var classes = useStyles();
    if (len < maxLength) {
        if (children) {
            return react_1["default"].createElement(react_1["default"].Fragment, null, children);
        }
        return react_1["default"].createElement(react_1["default"].Fragment, null, text);
    }
    if (isExpanded) {
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            children ? children : text,
            "\u00A0",
            react_1["default"].createElement("span", { className: classes.s, onClick: function () { return setExpand(false); } }, "See less")));
    }
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        text.slice(0, maxLength),
        "...",
        react_1["default"].createElement("br", null),
        react_1["default"].createElement("span", { className: classes.s, onClick: function () { return setExpand(true); } }, "See more")));
});
